var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "content",
      on: { focusout: _vm.temporaryRepair, focusin: _vm.focus },
    },
    [
      _c("div", { staticClass: "box iphone-box" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            {
              staticClass: "input-box",
              class: {
                error: !_vm.phoneValid,
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.tel,
                    expression: "tel",
                  },
                ],
                attrs: {
                  type: "text",
                  id: "iphone",
                  placeholder: "请输入手机号",
                  maxlength: 11,
                },
                domProps: { value: _vm.tel },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.tel = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.phoneValid,
                      expression: "!phoneValid",
                    },
                  ],
                  staticClass: "des",
                },
                [_vm._v("\n                请输入正确的手机号码\n            ")]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box name-box" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "input-box2" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.verificationCode,
                  expression: "verificationCode",
                },
              ],
              staticClass: "inputWidth",
              attrs: {
                type: "text",
                id: "name",
                placeholder: "请输入验证码",
                maxlength: 6,
              },
              domProps: { value: _vm.verificationCode },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.verificationCode = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            !_vm.getCode
              ? _c("div", {
                  staticClass: "getCode getCodeActive",
                  class: _vm.canGet ? "getCodeActive" : "getCodeNotBtn",
                  on: { click: _vm.clickGetCode },
                })
              : _c("div", { staticClass: "getCode getCodeNot" }, [
                  _vm._v("重新发送" + _vm._s(`${_vm.countdownText}`)),
                ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "btn",
        class: this.canGet && this.codeAct ? "activeBackImgBtn" : "backImgBtn",
        on: { click: _vm.getCoupon },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }